/**
 * Custom Site Specific Javascript
 *
 * This file is to add custom features to the website without having to modify
 * core/common assets. Define a custom class, and build new or overwrite
 * existing methods to create custom functionality.
 */

// Custom JavaScript code for Mobile Gaming Settlement site can be added here
console.log("Mobile Gaming Settlement custom.js loaded");

/**
 * Initializes a claim object.
 *
 * @param {Object} claim - The claim object to be initialized.
 * @returns {Object} The initialized claim object.
 */
export function customInitClaim(claim) {
    console.log("[Initiate claim]...");
    // Custom initialization code can be added here   
    return claim;
}

/**
 * Custom function to load a member.
 *
 * @param {Object} claim - The member object to be loaded.
 * @returns {Object} - The loaded member object.
 */
export function customLoadMember(claim) {
    console.log("[Load class member]...");
    // Custom member loading code can be added here
    return claim;
}

/**
 * Processes a claim for a custom member.
 *
 * @param {Object} claim - The claim to be processed.
 * @returns {Object} The processed claim.
 */
export function customProcessClaim(claim) {
    console.log("[Process claim]...");
    // Custom claim processing code can be added here
    return claim;
}

/**
 * Inserts a Spanish subheader before the first Spanish-language document on the
 * Important Documents page. This keeps the CMS data untouched while still
 * grouping the translated documents.
 *
 * @returns {void}
 */
export function insertSpanishDocumentsSubheader() {
    if (window.location.pathname.indexOf("/important-documents") === -1) return;

    const SPANISH_KEYWORDS = [/formulario/i, /aviso\s+de/i, /correo\s+electr/i];
    const HEADER_CLASS = "doc-item--spanish-subheader";

    // Run after the DOM has the rendered list.
    requestAnimationFrame(() => {
        const container = document.querySelector(".important-documents-container");
        if (!container) return;

        const docList = container.querySelector(".doc-list");
        if (!docList || docList.querySelector(`.${HEADER_CLASS}`)) return;

        const items = Array.from(docList.querySelectorAll("li.doc-item"));
        if (items.length === 0) return;

        const spanishAnchor = items.find((item) => {
            const text = (item.textContent || "").trim();
            return text && SPANISH_KEYWORDS.some((regex) => regex.test(text));
        });
        if (!spanishAnchor) return;

        const headerItem = document.createElement("li");
        headerItem.className = `doc-item doc-item--subheader mt-4 mb-2 ${HEADER_CLASS}`.trim();

        const heading = document.createElement("h3");
        heading.className = "doc-subheader-title";
        heading.textContent = "Documentos Importantes";
        headerItem.appendChild(heading);
        docList.insertBefore(headerItem, spanishAnchor);
    });
}
